module.exports = __webpack_public_path__ + "static/media/location-icon.e0ec8ba7.svg";